export default __webpack_public_path__ + "static/media/costos.6482e398.svg";